import { render } from "./OptionTable.vue?vue&type=template&id=607f53be&scoped=true&ts=true"
import script from "./OptionTable.vue?vue&type=script&lang=ts"
export * from "./OptionTable.vue?vue&type=script&lang=ts"

import "./OptionTable.vue?vue&type=style&index=0&id=607f53be&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607f53be"]])

export default __exports__